export default __webpack_public_path__ + "media/feature-1.91b79f96.svg";